/*jshint browserify: true */
'use strict';

module.exports = renderMultiLineTextBox;

/**
 * Render the lines for a multi-line textbox. These lines represent the baselines for text.
 * If a textbox is tall enough, it will be a multi-line textbox.
 *
 * @param {Number} fontSize - Font size.
 * @param {PDFedit.coordinates.Rectangle} elementRectangle - Rectangle for the textbox.
 * @param {Number} viewportScale - The viewport scale. 1.0 = 100%, 1.5 = 150%, etc.
 * @param {CanvasRenderingContext2D} canvasContext - HTML 2D canvas context for drawling the textbox lines to.
 */
function renderMultiLineTextBox(fontSize, elementRectangle, viewportScale, canvasContext) {
    if (elementRectangle.pdfHeight > fontSize * 2) {
        // If the height of the box is greater than double the fontsize, this will be a multi-line textbox.

        canvasContext.save();

        canvasContext.lineWidth = 1;
        canvasContext.setLineDash([3, 2]);

        var baseLineYpos = elementRectangle.viewportTop + (fontSize * viewportScale);

        while (baseLineYpos < elementRectangle.viewportTop + elementRectangle.viewportHeight) {
            // Render at half-past-the-pixel to ensure a crisp line
            var renderYpos = Math.round(baseLineYpos);
            renderYpos += 0.5;

            canvasContext.lineDashOffset = 0;
            canvasContext.strokeStyle = 'red';
            canvasContext.beginPath();
            canvasContext.moveTo(elementRectangle.viewportLeft, renderYpos);
            canvasContext.lineTo(elementRectangle.viewportLeft + elementRectangle.viewportWidth, renderYpos);
            canvasContext.stroke();

            baseLineYpos += (fontSize * viewportScale);
        }

        canvasContext.restore();
    }
}